import { Search } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";

export const DockSheet = ({ open, onOpenChange, title, description, testId, children }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent side="bottom" onInteractOutside={(e) => e.target.closest?.("[data-sonner-toaster]") && e.preventDefault()} className="max-h-[85vh] h-[85vh] sm:h-[75vh] flex flex-col bg-[#0E131D] border-white/10 rounded-t-2xl sm:max-w-2xl sm:mx-auto" data-testid={testId}>
      <SheetHeader className="text-left">
        <SheetTitle className="font-display text-2xl">{title}</SheetTitle>
        {description && <SheetDescription>{description}</SheetDescription>}
      </SheetHeader>
      {children}
    </SheetContent>
  </Sheet>
);

export const SearchBox = ({ value, onChange, placeholder, testId }) => (
  <label className="mt-4 flex items-center gap-2 rounded-xl border border-white/10 bg-white/[0.03] px-3 py-2">
    <Search size={14} className="text-slate-500" />
    <input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="bg-transparent outline-none text-base sm:text-sm flex-1" data-testid={testId} />
  </label>
);

export const plain = (t) => (t || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
